import {
  Banner,
  Text,
  useThemeProvider,
} from "@towersystems/roam-common-native";
import { useTranslation } from "../../../../utilities/i18n";
import { AntDesign } from "@expo/vector-icons";

export interface LocationWarningBannerProps {
  name?: string;
}

export const LocationWarningBanner = ({ name }: LocationWarningBannerProps) => {
  const { t } = useTranslation("sales");
  const { colors } = useThemeProvider();

  const normalizedName = name ? name : t("common:unknown_location");
  return (
    <Banner
      title={t("banner.location_warning.title")}
      status="warning"
      icon={
        <AntDesign
          name="exclamationcircle"
          size={20}
          color={colors.borderWarning}
        />
      }
    >
      <Text>
        {t("banner.location_warning.description", {
          name: normalizedName,
        })}
      </Text>
    </Banner>
  );
};
